import { get as _get } from 'lodash';
import { getArgoConfig } from '../../window';
import {UserPreferenceClient} from "./UserPreferenceClient";
import {UserPreferenceStubClient} from "./UserPreferenceStubClient";

export interface Attribute {
    type: string;
    value: string;
}

export interface PreferenceMeta{
    preferenceName: string,
    preferenceConfig: string
}

export function getNoOfPreferences(config: any): number {
    const appConfig = _get(config, 'argo.appConfig', false);
    return appConfig ? _get(appConfig, 'noOfPreferences', 0) : 0;
}

export function getUserPreferenceClient() {
    const argoConfig = getArgoConfig();
    return getNoOfPreferences(argoConfig) !== 0 ? new UserPreferenceClient() : new UserPreferenceStubClient();
}